import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const GET_ORGANIZATION_FAIL = "ORGANIZATION:GET_ORGANIZATION_FAIL";

export interface GetOrganizationFailAction extends Action {
  type: typeof GET_ORGANIZATION_FAIL;
  organization: OrganizationKeyName;
}

export const getOrganizationFailAction = (
  organization: OrganizationKeyName
): GetOrganizationFailAction => ({
  type: GET_ORGANIZATION_FAIL,
  organization,
});
